<template>
  <div class="generating">
    <div class="generating-background"/>
    <div class="generating-message-wrapper">
      <div class="generating-message-container ai-bg">
        <div class='generating-message-content'>
          <div
            v-if="generationError"
            class="generation-error-message">
            <p>{{ generationError }}</p>
            <div>
              <button
                class="btn btn-primary btn-sm"
                @click="$emit('retry')">
                Retry
              </button>
              <button
                class="btn btn-sm"
                @click="$emit('cancel')">
                Cancel
              </button>
            </div>
          </div>
          <div v-else>
            <img
              class="generating-animation"
              src="~@/assets/ai_transition_animation.gif"
              alt="AI Powered Feature">
            <p role="status">
              Compiling Goalbook Toolkit strategies...<span class="sr-only">Please wait a moment.</span>
            </p>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>

export default {
  name: 'GeneratingMessage',
  props: {
    generationError: {
      type: String,
      default: ''
    }
  }
}
</script>



<style scoped lang='less'>
@import "~@/variables.less";

.generating-background {
  position: absolute;
  width: 100%;
  height: 100%;
  top: 0;
  opacity: 0.75;
  background-color: white;
}
.generating-message-wrapper {
  position: absolute;
  width: 100%;
  height: 100%;
  top: 0;
  background-color: transparent;
  opacity: 1;
  display: flex;
  justify-content: center;
  align-items: center;
}
.generating-message-container {
  width: 250px;
  padding-top: 0.75rem;
  box-shadow: 0 0 10px rgba(0,0,0,0.5);
  border-radius: 0.75rem;

  .generating-message-content {
    height: 250px;
    padding: 1rem;
    background-color: white;
    border-bottom-left-radius: 0.75rem;
    border-bottom-right-radius: 0.75rem;
    font-size: 16px;
    text-align: center;

    .generating-animation {
      width: 100%;
      height: auto;
    }
  }

  .generation-error-message {
    display: flex;
    flex-direction: column;
    height: 100%;
    justify-content: space-evenly;
    align-items: center;

    button {
      margin-bottom: 0.5rem;
    }
  }
}
</style>
